import "core-js/stable"
import React from "react"
import ReactDOM from "react-dom"
import LandingApp from "../../landing/LandingApp"

document.addEventListener("DOMContentLoaded", () => {
  const ele = document.getElementById("app")
  const userType = ele.getAttribute("data-user-type")

  ReactDOM.render(<LandingApp defaultUserType={userType} />, ele)
})
